// Wishlist + Custom Made functionality for Pipeline theme
(function () {
  const WISHLIST_KEY = 'pipeline_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function isInWishlist(productId) {
    return getWishlist().includes(String(productId));
  }

  function toggleWishlist(productId, productData) {
    let list = getWishlist();
    let savedProducts = getSavedProducts();
    const id = String(productId);

    if (list.includes(id)) {
      list = list.filter(i => i !== id);
      delete savedProducts[id];
    } else {
      list.push(id);
      savedProducts[id] = productData;
    }

    saveWishlist(list);
    localStorage.setItem('pipeline_wishlist_data', JSON.stringify(savedProducts));
    updateAllButtons(id);
    updateNavCount();
  }

  function getSavedProducts() {
    try {
      return JSON.parse(localStorage.getItem('pipeline_wishlist_data')) || {};
    } catch (e) {
      return {};
    }
  }

  function updateAllButtons(productId) {
    const buttons = document.querySelectorAll(`.wishlist-btn[data-product-id="${productId}"]`);
    const inList = isInWishlist(productId);
    buttons.forEach(btn => {
      btn.classList.toggle('wishlist-btn--active', inList);
      btn.setAttribute('aria-label', inList ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function updateNavCount() {
    const count = getWishlist().length;
    const counters = document.querySelectorAll('[data-wishlist-count]');
    counters.forEach(el => {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ✅ FIX: Guard against double event binding using data attribute flag
  function initButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      // Skip if already initialised — prevents double-click bug
      if (btn.dataset.wishlistInit === 'true') return;
      btn.dataset.wishlistInit = 'true';

      const id = btn.getAttribute('data-product-id');
      if (isInWishlist(id)) {
        btn.classList.add('wishlist-btn--active');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const productId = this.getAttribute('data-product-id');
        const productData = {
          id: productId,
          title: this.getAttribute('data-product-title'),
          url: this.getAttribute('data-product-url'),
          image: this.getAttribute('data-product-image'),
          price: this.getAttribute('data-product-price'),
        };
        toggleWishlist(productId, productData);
      });
    });
  }

  // ✅ FIX: Mobile wishlist nav — Pipeline theme intercepts clicks on header
  // Use capture phase + touchend to bypass theme's event delegation
  function initMobileWishlistNav() {
    var navLink = document.querySelector('[data-wishlist-nav]');
    if (!navLink) return;

    var tapped = false;

    // touchend fires before the theme's click handler — navigate immediately
    navLink.addEventListener('touchend', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      tapped = true;
      window.location.href = '/pages/wishlist';
    }, { passive: false, capture: true });

    // Fallback for desktop/non-touch (capture phase runs before theme JS)
    navLink.addEventListener('click', function (e) {
      if (tapped) { tapped = false; return; }
      e.stopImmediatePropagation();
      window.location.href = '/pages/wishlist';
    }, { capture: true });
  }

  // Wishlist page rendering
  function renderWishlistPage() {
    const container = document.getElementById('wishlist-page-container');
    if (!container) return;

    const savedProducts = getSavedProducts();
    const list = getWishlist();

    if (list.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
          </svg>
          <p>Your wishlist is empty</p>
          <a href="/collections/all" class="btn">Continue Shopping</a>
        </div>`;
      return;
    }

    let html = '<div class="wishlist-grid">';
    list.forEach(id => {
      const p = savedProducts[id];
      if (!p) return;
      html += `
        <div class="wishlist-item" data-wishlist-item-id="${p.id}">
          <div class="wishlist-item__image">
            <a href="${p.url}">
              <img src="${p.image}" alt="${p.title}" loading="lazy">
            </a>
            <button class="wishlist-item__remove" data-remove-id="${p.id}" aria-label="Remove from wishlist">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <div class="wishlist-item__info">
            <a href="${p.url}" class="wishlist-item__title">${p.title}</a>
            <p class="wishlist-item__price">${p.price}</p>
            <a href="${p.url}" class="btn wishlist-item__btn">View Product</a>
          </div>
        </div>`;
    });
    html += '</div>';
    container.innerHTML = html;

    container.querySelectorAll('.wishlist-item__remove').forEach(btn => {
      btn.addEventListener('click', function () {
        const id = this.getAttribute('data-remove-id');
        toggleWishlist(id, {});
        const item = container.querySelector(`[data-wishlist-item-id="${id}"]`);
        if (item) item.remove();
        if (getWishlist().length === 0) renderWishlistPage();
      });
    });
  }

  // ===== CUSTOM MADE BUTTON TEXT UPDATER =====
  function updateCustomMadeButton(variantId) {
    var productJson = document.querySelector('[data-product-json]');
    if (!productJson) return;

    try {
      var product = JSON.parse(productJson.textContent);

      // If product has preorder tag, do not override — Liquid already handled it
      var isPreorder = product.tags && product.tags.some(function (tag) {
        return tag.toLowerCase() === 'preorder';
      });
      if (isPreorder) return;

      var variant = null;
      if (variantId) {
        variant = product.variants.find(function (v) { return v.id == variantId; });
      }
      if (!variant) {
        var urlParams = new URLSearchParams(window.location.search);
        var urlVariantId = urlParams.get('variant');
        if (urlVariantId) {
          variant = product.variants.find(function (v) { return v.id == urlVariantId; });
        }
      }
      if (!variant) variant = product.variants[0];
      if (!variant) return;

      var isCustomMade = variant.inventory_policy === 'continue' && variant.inventory_quantity <= 0;
      var btn = document.querySelector('[data-add-to-cart]');
      var btnText = document.querySelector('[data-add-to-cart-text]');
      var noticeBox = document.querySelector('.custom-made-notice');

      if (!btn || !btnText) return;

      if (isCustomMade) {
        btnText.textContent = 'Add to Cart';
        btn.removeAttribute('disabled');
        btn.classList.remove('btn--custom-made');
        if (noticeBox) noticeBox.style.display = 'flex';
      } else {
        if (btnText.textContent === 'Add to Cart' || btnText.textContent === 'Custom Made') {
          btnText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          if (!variant.available) btn.setAttribute('disabled', 'disabled');
          btn.classList.remove('btn--custom-made');
        }
        if (noticeBox) noticeBox.style.display = 'none';
      }
    } catch (e) {
      console.error('Custom Made error:', e);
    }
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    initMobileWishlistNav();
    updateNavCount();
    renderWishlistPage();
    updateCustomMadeButton();
  });

  // ✅ Re-init buttons when Pipeline theme dynamically loads new product cards
  // (e.g. collection filters, infinite scroll) — guard in initButtons() prevents duplicates
  document.addEventListener('theme:section:load', function () {
    initButtons();
    updateNavCount();
  });

  // Update when variant changes (Pipeline theme events)
  document.addEventListener('theme:variant:change', function (e) {
    var variantId = e.detail && e.detail.variant && e.detail.variant.id;
    updateCustomMadeButton(variantId);
  });

  document.addEventListener('variantChange', function (e) {
    var variantId = e.detail && e.detail.variant && e.detail.variant.id;
    updateCustomMadeButton(variantId);
  });

})();